import { object, bool } from 'yup';

export default object().shape({
  cardNumValid: bool().oneOf([true]),
  cardExpValid: bool().oneOf([true]),
  cardCVCValid: bool().oneOf([true])
});
